import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../redux/hook'
import { Icon } from '@iconify/react'
import React from 'react'
import DataGrid from 'react-data-grid'
import './index.css'
import { useNavigate } from 'react-router-dom'
import { personalTimeOff } from '../../../../features/dashboard/api'
import { SHOW_LOADER, HIDE_LOADER } from '../../../../redux/slices/LoaderSlice'
import { PersonalTimeOff } from '../../../../features/dashboard/types'
import CustomPagination from '../../../../components/Pagination'
import { formatDate } from '../../../resources/empresources/utils'
import DeletePersonalTimeoff from '../../components/deletePersonalTimeoff'
import { assignedTimeOffManager } from '../../../../features/dashboard/api'
import SelectField from '../../../../components/Form/Select'
import { setTimeoffRequestsList } from '../../slice'
import { getOptions } from '../../../userslisting/viewuser/utils'
import { lookupValuesI } from '../../pages/type'
import { getLookupValues } from '../../../userslisting/createuser/api'
import { Filter } from '../../../../features/dashboard/types'

const Details: React.FC = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const { id, role } = useAppSelector((state) => state.persistedReducers.user)
    const timeOffRequestsState = useAppSelector(
        (state) => state.timeOffRequests.timeoffRequestsList
    )

    const [perosnaltimeOff, setPerosnalTimeOff] = useState<PersonalTimeOff[]>(
        []
    )
    const [assignedtimeOff, setAssignedTimeOff] = useState<PersonalTimeOff[]>(
        []
    )
    const [deleteTimeoffId, setDeleteTimeoffId] = useState<string>('')
    const [delmodal, setShowDelModal] = React.useState<boolean>(false)
    const [currentPage, setCurrentPage] = useState<number>(1)
    const [totalCount, setTotalCount] = useState<number>(0)
    const [currentassignedPage, setCurrentAssignedPage] = useState<number>(1)
    const [assignedtotalCount, setAssignedTotalCount] = useState<number>(0)
    const [isAssignedRecords, setIsAssignedRecords] =
        useState<string>('Personal')
    const [lookupValues, setLookupValues] = useState<lookupValuesI[]>([])

    const totalPages = Math.ceil(totalCount / 10)
    const assignedtotalPages = Math.ceil(assignedtotalCount / 10)

    useEffect(() => {
        dispatch(SHOW_LOADER())
        const getLookUpData = async () => {
            try {
                const lookupValues = await getLookupValues()
                setLookupValues(lookupValues.data)
            } catch (err) {
                console.error('Error fetching:', err)
            } finally {
                dispatch(HIDE_LOADER())
            }
        }
        if (role === 'Manager') {
            getLookUpData()
        }
    }, [])

    useEffect(() => {
        const gettimeOff = async () => {
            try {
                dispatch(SHOW_LOADER())
                const response = await personalTimeOff(10, currentPage, id)
                setPerosnalTimeOff(response?.data?.data)
                dispatch(setTimeoffRequestsList(response?.data?.data))
                setTotalCount(response?.data?.totalCount)
                dispatch(HIDE_LOADER())
            } catch (err) {
                // Handle any errors here
                console.error('Error fetching:', err)
            } finally {
                dispatch(HIDE_LOADER())
            }
        }

        gettimeOff()
    }, [currentPage])

    useEffect(() => {
        if (timeOffRequestsState !== null) {
            setPerosnalTimeOff(timeOffRequestsState)
        }
    }, [timeOffRequestsState])

    useEffect(() => {
        const getassignedtimeOff = async () => {
            const statusOptions = getOptions(lookupValues, 'Status').filter(
                (item) => item.label === 'Pending'
            )
            const filters: Filter[] = []

            if (statusOptions) {
                filters.push({
                    field: 'StatusId',
                    operator: 'eq',
                    value: Number(statusOptions[0]?.value),
                })
            }

            try {
                const response = await assignedTimeOffManager(
                    10,
                    currentassignedPage,
                    id,
                    filters
                )
                setAssignedTimeOff(response?.data?.data)
                setAssignedTotalCount(response?.data?.totalCount)
                dispatch(HIDE_LOADER())
            } catch (err) {
                // Handle any errors here
                console.error('Error fetching:', err)
                dispatch(HIDE_LOADER())
            }
        }
        if (role === 'Manager') {
            getassignedtimeOff()
        }
    }, [currentassignedPage])

    const getCurrentPage = (page: number, peronsnal: boolean) => {
        peronsnal ? setCurrentPage(page) : setCurrentAssignedPage(page)
    }

    const handleDeleteTimeoff = async (id: string) => {
        setDeleteTimeoffId(id)
        setShowDelModal(true)
    }

    const column = [
        {
            key: 'leaveType',
            name: 'Type',
            resizable: true,
            sortable: true,
            frozen: true,
        },
        {
            key: 'startDate',
            name: 'Date',
            resizable: true,
            sortable: true,
            renderCell: (props: any) => {
                return (
                    <div className="">
                        {formatDate(props.row.startDate)} -{' '}
                        {formatDate(props.row.endDate)}
                    </div>
                )
            },
        },
        {
            key: 'status',
            name: 'Status',
            resizable: true,
            sortable: true,
            renderCell: (props: any) => {
                return (
                    <div
                        className={
                            props.row.status === 'Declined'
                                ? 'decl'
                                : props.row.status === 'Approved'
                                  ? 'appr'
                                  : 'status'
                        }
                    >
                        {props.row.status}
                    </div>
                )
            },
        },
        {
            key: 'actions',
            name: 'Actions',
            resizable: true,
            renderCell: (props: any) => (
                <>
                    <div className="dropdown-custom-link">
                        <Icon
                            icon="icon-park-outline:delete"
                            className="icon-secondary"
                            cursor={'pointer'}
                            onClick={() => handleDeleteTimeoff(props.row.id)}
                        />
                        <Icon
                            icon="mdi:eye"
                            className="icon-success"
                            cursor={'pointer'}
                            onClick={() =>
                                navigate(`/time-off/view/${props.row.id}`)
                            }
                        />
                    </div>
                </>
            ),
        },
    ]

    const column1 = [
        {
            key: 'name',
            name: `Name`,
            resizable: true,
            sortable: true,
        },
        {
            key: 'leaveType',
            name: `Type`,
            resizable: true,
            sortable: true,
        },
        {
            key: 'status',
            name: `Status`,
            resizable: true,
            sortable: true,
            renderCell: (props: any) => {
                return (
                    <div
                        className={
                            props.row.status === 'Pending' ? 'status' : 'appr'
                        }
                    >
                        {props.row.status}
                    </div>
                )
            },
        },
        {
            key: 'date',
            name: `Dates`,
            resizable: true,
            sortable: true,
            renderCell: (props: any) => {
                return (
                    <div className="">
                        {formatDate(props.row.startDate)} -{' '}
                        {formatDate(props.row.endDate)}
                    </div>
                )
            },
        },
        {
            key: 'actions',
            name: 'Actions',
            resizable: true,
            renderCell: (props: any) => (
                <>
                    <div className="dropdown-custom-link">
                        <Icon
                            icon="mdi:eye"
                            className="icon-success"
                            cursor={'pointer'}
                            onClick={() =>
                                navigate(`/time-off/view/${props.row.id}`)
                            }
                        />
                    </div>
                </>
            ),
        },
    ]

    return (
        <div>
            <DeletePersonalTimeoff
                show={delmodal}
                onClose={setShowDelModal}
                id={deleteTimeoffId}
            />
            <div className="col-12">
                <>
                    <div className="col-sm-3">
                        {role === 'Manager' && (
                            <SelectField
                                name="leaveType"
                                label=""
                                options={[
                                    {
                                        value: 'Assigned',
                                        label: 'Assigned Time-offs',
                                    },
                                    {
                                        value: 'Personal',
                                        label: 'Personal Time-offs',
                                    },
                                ]}
                                value={isAssignedRecords}
                                onChange={(e) =>
                                    setIsAssignedRecords(e.target.value)
                                }
                                onBlur={() => {
                                    return
                                }}
                                error={''}
                                touched={true}
                                defaultValue="option1"
                            />
                        )}
                    </div>

                    {(isAssignedRecords === 'Personal' &&
                        perosnaltimeOff &&
                        perosnaltimeOff?.length > 0) ||
                    (isAssignedRecords === 'Assigned' &&
                        assignedtimeOff &&
                        assignedtimeOff?.length > 0) ? (
                        <DataGrid
                            className="data-grid-table"
                            columns={
                                isAssignedRecords === 'Assigned'
                                    ? column1
                                    : column
                            }
                            rows={
                                isAssignedRecords === 'Assigned'
                                    ? assignedtimeOff
                                    : perosnaltimeOff
                            }
                            rowHeight={60}
                            headerRowHeight={40}
                        />
                    ) : (
                        <>
                            <div className="no-records">
                                You don’t have any upcoming Paid Time Off.
                            </div>
                        </>
                    )}
                    <div className="mt-3">
                        {perosnaltimeOff?.length > 0 && (
                            <CustomPagination
                                totalPages={
                                    isAssignedRecords === 'Assigned'
                                        ? assignedtotalPages
                                        : totalPages
                                }
                                currentPage={
                                    isAssignedRecords === 'Assigned'
                                        ? currentassignedPage
                                        : currentPage
                                }
                                getPageNumber={(page: number) =>
                                    getCurrentPage(
                                        page,
                                        isAssignedRecords === 'Assigned'
                                            ? false
                                            : true
                                    )
                                }
                            />
                        )}
                    </div>
                </>
            </div>
        </div>
    )
}

export default Details
